import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    month: {
      less: '{amount} less than previous month',
      more: '{amount} more than previous month',
    },
    quarter: {
      less: '{amount} less than previous quarter',
      more: '{amount} more than previous quarter',
    },
    stable: 'Stable',
    unknown: {
      less: '{amount} less than previous period',
      more: '{amount} more than previous period',
    },
    year: {
      less: '{amount} less than previous year',
      more: '{amount} more than previous year',
    },
  },
  fr: {
    month: {
      less: '{amount} de moins que le mois précédent',
      more: '{amount} de plus que le mois précédent',
    },
    quarter: {
      less: '{amount} de moins que le trimestre précédent',
      more: '{amount} de plus que le trimestre précédent',
    },
    stable: 'Stable',
    unknown: {
      less: '{amount} de moins que la période précédente',
      more: '{amount} de plus que la période précédente',
    },
    year: {
      less: "{amount} de moins que l'année précédente",
      more: "{amount} de plus que l'année précédente",
    },
  },
} as const);

export default locales;
